<script setup lang="ts">
withDefaults(defineProps<{
  title: string
  description?: string | undefined
  showMark?: boolean
}>(), {
  showMark: true
})
</script>

<template>
  <section class="tq-empty" aria-live="polite">
    <div v-if="showMark" class="tq-empty__mark" aria-hidden="true">
      <UIcon name="i-lucide-ticket" />
      360
    </div>
    <h2 class="tq-empty__title">{{ title }}</h2>
    <p v-if="description" class="tq-empty__description">{{ description }}</p>
    <div class="tq-empty__actions"><slot /></div>
  </section>
</template>

<style scoped>
.tq-empty { display: grid; justify-items: center; gap: 0.8rem; border: 1px dashed var(--tq-border); border-radius: var(--tq-radius-xl); background: color-mix(in oklch, var(--tq-bg-elevated) 76%, transparent); padding: clamp(1.5rem, 4vw, 2.4rem); text-align: center; }
.tq-empty__mark { display: inline-flex; align-items: center; gap: 0.38rem; border-radius: var(--tq-radius-pill); background: var(--tq-accent-chip-bg); color: var(--tq-accent-readable); padding: 0.45rem 0.85rem; font-weight: 700; letter-spacing: 0.08em; }
.tq-empty__title { margin: 0; font-size: clamp(1.35rem, 2.5vw, 2.2rem); letter-spacing: -0.055em; }
.tq-empty__description { max-width: 42rem; margin: 0; color: var(--tq-text-muted); line-height: 1.6; }
:deep(.iconify) { width: 1rem; height: 1rem; }
</style>
